import type { ApiResponse } from '@abaninja/types';

import { httpClient } from '@abaninja/util-http-client';
import { createCancellablePromise } from '@abaninja/util-store';

import type { Settings } from '../@types';

export function getCustomerPortalSettings() {
  return createCancellablePromise(
    ({ signal }) => httpClient.get<ApiResponse<Settings>>('/customer-portal/v2/settings', { signal }),
  );
}
